export default __webpack_public_path__ + "static/media/banner-21.63f33882.png";